import request_types from "@/utils/cp_req_init_data/modules/request_types";
import cp_simulator from "@/utils/cp_req_init_data/modules/cp_simulator";

export default [
  {
    path: "/rnp",
    name: "RoleAndPermission",
    component: () => import("../views/custom/RoleAndPermission.vue")
  },
  {
    path: "/test/cp_request",
    name: "CpRequestTest",
    component: () => import("../views/custom/test/CpRequestTest.vue"),
    props: {
      whitelist: Object.keys(request_types)
    }
  },
  {
    path: "/lms/dashboard",
    name: "LMSDashboard",
    component: () => import("../views/custom/LMSDashboard.vue")
  },
  {
    path: "/lms/cp_simulator",
    name: "CpSimulator",
    component: () => import("../views/custom/test/CpRequestTest.vue"),
    props: {
      whitelist: Object.keys(cp_simulator)
    }
  },
  // {
  //   path: "/lms/config",
  //   name: "LmsConfig",
  //   component: () => import("../views/custom/LmsConfig.vue"),
  // },
  {
    path: "/realtime/log",
    name: "RealtimeWsLogPage",
    component: () => import("../views/custom/RealtimeWsLog.vue"),
  },
  {
    path: "data_rotation_setup",
    name: "DataRotationSetup",
    component: () => import("../views/custom/DataRotationSetup")
  },
  {
    path: "third_party_conf",
    name: "ThirdPartyConf",
    component: () => import("../views/custom/ThirdPartyConf")
  },
  {
    path: "app_config",
    name: "AppConfig",
    component: () => import("../views/custom/app_config")
  },
  {
    path: "/cp_locs/map",
    name: "CpMap",
    component: () => import("../views/custom/map/CpMap.vue")
  },
  {
    path: "/cp_locs/floor_plan",
    name: "CpFloorPlan",
    component: () => import("../views/custom/floor-plan/CpFloorPlan.vue")
  }
]
